var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('masonry',{attrs:{"cols":{default: 2, 576: 1},"gutter":30}},_vm._l((_vm.news),function(item,index){return _c('news-card',{key:index,attrs:{"data":item}})}))],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfa49cc8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/news-feed.vue
// module id = k7B7
// module chunks = 0